import React, { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "@/context/ThemeContext";
import { CompConfigProvider, DEFAULT_COMP_CONFIG } from "@/context/CompConfigContext";
import ReactDOM from "react-dom/client"; // Import from 'react-dom/client'
import { store } from "./lib/redux/store";
import { Provider } from "react-redux";
import "./index.css";

import { BrowserRouter } from "react-router-dom";

import { ENABLE_ACCESS_CHECK } from "@/config";
import XoSoCompound from "./components/XoSoCompound";
import XoSoSidebar from "./components/XoSoSidebar";
import VietlottCompound from "./components/VietlottCompound";
import VietlottSidebar from "./components/VietlottSidebar";
import DienToan123 from "./components/DienToan123";
import SidebarDienToan123 from "./components/SidebarDienToan123";
import ThanTai04 from "./components/ThanTai04";
import SidebarThanTai04 from "./components/SidebarThanTai04";
import DienToan6x36 from "./components/DienToan6x36";
import SidebarDienToan6x36 from "./components/SidebarDienToan6x36";
import XoSoTruyenThongV2Dark from "./components/XoSoTruyenThongV2Dark";
import XoSoTruyenThongV3Light from "./components/XoSoTruyenThongV3Light";
import XoSoTruyenThongV3Dark from "./components/XoSoTruyenThongV3Dark";
import XsmnV3Light from "./components/XsmnV3Light";
import XsmnV3Dark from "./components/XsmnV3Dark";
import XsmnV4Light from "./components/XsmnV4Light";
import XsmtV4Light from "./components/XsmtV4Light";
import XsmbV4Light from "./components/XsmbV4Light";
import QuayThuV4Light from "./components/QuayThuV4Light";
import { resolveConfigDow } from "./components/XsmnV4Light/dow";
import XsmbV3Light from "./components/XsmbV3Light";
import XsmbV3Dark from "./components/XsmbV3Dark";
import XsmtV3Light from "./components/XsmtV3Light";
import XsmtV3Dark from "./components/XsmtV3Dark";

const isReactBuild = process.env.REACT_APP_BUILD_TARGET === "react";
const shouldCheckAppAccess =
  String(ENABLE_ACCESS_CHECK ?? "true").trim().toLowerCase() !== "false";


if (isReactBuild) {
  renderApps("xoso-root");
}

const componentMap = {
  xosocompound: XoSoCompound,
  xososidebar: XoSoSidebar,
  vietlottcompound: VietlottCompound,
  vietlottsidebar: VietlottSidebar,
  dientoan123: DienToan123,
  sidebardientoan123: SidebarDienToan123,
  thantai04: ThanTai04,
  sidebarthantai04: SidebarThanTai04,
  dientoan6x36: DienToan6x36,
  sidebardientoan6x36: SidebarDienToan6x36,
  xosotruyenthongv2dark: XoSoTruyenThongV2Dark,
  xosotruyenthongv3light: XoSoTruyenThongV3Light,
  xosotruyenthongv3dark: XoSoTruyenThongV3Dark,
  xsmnv3light: XsmnV3Light,
  xsmnv3dark: XsmnV3Dark,
  xsmnv4light: XsmnV4Light,
  xsmtv4light: XsmtV4Light,
  xsmbv4light: XsmbV4Light,
  quaythuv4light: QuayThuV4Light,
  xsmbv3light: XsmbV3Light,
  xsmbv3dark: XsmbV3Dark,
  xsmtv3light: XsmtV3Light,
  xsmtv3dark: XsmtV3Dark,
};

function parseDataConfig(rootElement) {
  const raw = rootElement.getAttribute("data-config");
  if (!raw || typeof raw !== "string") return DEFAULT_COMP_CONFIG;
  try {
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_COMP_CONFIG, ...(parsed && typeof parsed === "object" ? parsed : {}) };
  } catch {
    return DEFAULT_COMP_CONFIG;
  }
}

function App({ league, type, config, category, dataDefault, dow }) {
  const Component = componentMap[type] || (() => <div>Unknown type</div>);
  return (
    <Component
      league={league}
      config={config}
      category={category}
      dataDefault={dataDefault}
      dow={dow}
    />
  );
}

function renderApps(className) {
  const rootElements = document.getElementsByClassName(className);

  Array.from(rootElements).forEach(async (rootElement) => {
    const type = rootElement.getAttribute("data-type");
    const league = rootElement.getAttribute("data-league");
    const category = rootElement.getAttribute("data-category");
    const dataDefault = rootElement.getAttribute("data-default");
    const theme = rootElement.getAttribute("data-theme");
    const config = parseDataConfig(rootElement);
    config.dow = resolveConfigDow(config.dow);
    const hasDataConfig = !!rootElement.getAttribute("data-config");
    const root = ReactDOM.createRoot(rootElement);

    // if (shouldCheckAppAccess) {
    //   const dataAccessKey = (rootElement.getAttribute("data-access-key") || "").trim();
    //   let access;
    //   if (dataAccessKey) {
    //     access = await resolveAppAccessWithDefaultKey({
    //       type,
    //       activeStatus: APP_KEY_ACCESS.activeStatus,
    //       messages: APP_KEY_ACCESS_MESSAGES,
    //       key: dataAccessKey,
    //     });
    //     if (!access.allowed) {
    //       access = await resolveAppAccessWithDefaultKey({
    //         type,
    //         activeStatus: APP_KEY_ACCESS.activeStatus,
    //         messages: APP_KEY_ACCESS_MESSAGES,
    //       });
    //     }
    //   } else {
    //     access = await resolveAppAccessWithDefaultKey({
    //       type,
    //       activeStatus: APP_KEY_ACCESS.activeStatus,
    //       messages: APP_KEY_ACCESS_MESSAGES,
    //     });
    //   }

    //   if (!access.allowed) {
    //     root.render(<AppAccessMessage message={access.message} />);
    //     return;
    //   }
    // }

    root.render(
      <Suspense fallback={<p>Loading...</p>}>
        <Provider store={store}>
          <ThemeProvider initialTheme={theme} themeRoot={rootElement}>
            <CompConfigProvider config={config} hasDataConfig={hasDataConfig}>
              <BrowserRouter>
                <HelmetProvider>
                  <App
                    type={type}
                    league={league}
                    config={config}
                    category={category}
                    dataDefault={dataDefault}
                    dow={config.dow}
                  />
                </HelmetProvider>
              </BrowserRouter>
            </CompConfigProvider>
          </ThemeProvider>
        </Provider>
      </Suspense>
    );
  });
}
